export const openChat = () => {
  window.LiveChatWidget?.call('maximize')
}

export const hideChat = () => {
  window.LiveChatWidget?.call('hide')
}

export const showChat = () => {
  window.LiveChatWidget?.call('minimize')
}
